import NavBar from '@/components/NavBar';
import SideBar from '@/components/SideBar';
import { NavigationBlockerContext } from '@/context/NavigationBlockerContext';
import { ErrorBoundaryWithLocation } from '@/ErrorBoundaryWithLocation';
import { resetLogoutTimer } from '@/services/inactivityTimeOut';
import { useUserStore } from '@/stores/user';
import React, { useContext, useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const Template: React.FC = () => {
  const topRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const userStore = useUserStore((state) => state);
  const { setIsDirty } = useContext(NavigationBlockerContext);

  useEffect(() => {
    if (userStore.InactivityTimeout || !userStore.accessToken) navigate('/login');
  }, [userStore]);

  // Clear any stale unsaved-changes flag once navigation to a new page has
  // committed, so the sidebar confirmation alert does not leak into list views.
  useEffect(() => {
    setIsDirty(false);
  }, [location.pathname, setIsDirty]);

  useEffect(() => {
    if (location.pathname === '/') navigate('/dashboard', { replace: true });
  }, [location, navigate]);

  useEffect(() => {
    const handleStorageChange = () => {
      window.location.reload();
    };

    window.addEventListener('storage', handleStorageChange);
    resetLogoutTimer();
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <>
      <div className="flex flex-col h-screen overflow-hidden">
        <div className="z-20">
          <NavBar />
        </div>
        <div className="flex flex-1 overflow-hidden">
          <div className={`z-10 hidden md:block`}>
            <SideBar />
          </div>
          <div
            className="z-0 mt-[75px] w-full flex min-w-0 flex-1 flex-col items-stretch md:ml-[250px] p-8 pb-14 overflow-auto scrollbar-hide"
            ref={topRef}
          >
            <ErrorBoundaryWithLocation>
              <Outlet />
            </ErrorBoundaryWithLocation>
          </div>
        </div>
      </div>
    </>
  );
};

export default Template;
